import React, { useMemo } from 'react'
import { palettes } from '@manychat/manyui'

import { convertToIconString } from 'common/builder/components/chart/FlowChart/lib/utils/convertToIconString'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartTrigger } from 'common/builder/components/chart/FlowChart/types/FlowChartTrigger'

import * as triggerStyle from './Trigger.styles'

interface TriggerDefaultContentProps {
  trigger: FlowChartTrigger
}

export const TriggerDefaultContent = ({ trigger }: TriggerDefaultContentProps) => {
  const SubtitleIcon = useMemo(() => {
    if (!trigger.subtitleIcon) return null

    return convertToIconString(trigger.subtitleIcon, {
      size: sharedStyles.IconSizes.SMALL_MEDIUM * 2,
      color: palettes.typography.disabledFG,
    })
  }, [trigger.subtitleIcon])

  return (
    <>
      <richtext style={triggerStyle.TextStyle} text={trigger.title} />

      <view
        style={SubtitleIcon ? triggerStyle.SubtitleWithIconStyle : triggerStyle.ViewColumnStyle}
      >
        {SubtitleIcon && <sprite style={triggerStyle.SubtitleIcon} image={SubtitleIcon} />}

        <view style={triggerStyle.ViewColumnStyle}>
          {trigger.subtitle.map((subtitleRow, index) => (
            <richtext
              key={subtitleRow + index}
              style={triggerStyle.SubTextStyle}
              text={subtitleRow}
            />
          ))}
        </view>
      </view>
    </>
  )
}
